import React from "react";
import { Modal } from "react-bootstrap";
import { MDBTable, MDBTableBody, MDBTableHead } from "mdbreact";
import { th } from "../../../utils/helpers";
import { Button } from "../../../styles";
import { useSalesContext } from "../../../context/sales_context";
import { useUserContext } from "../../../context/user_context";

const ConfirmSales = (props) => {

    const { salesAdd, orderItem, sending, total_vat, vat_value } = props;

    console.log(props);


    const {
        orderField,
        showConfirmSales, closeConfirmSales
    } = useSalesContext();

    const {
        businessData
    } = useUserContext();

    return (
        <>
            <Modal
                show={showConfirmSales}
                onHide={closeConfirmSales}
                backdrop="static"
                keyboard={true}
                centered
                size="lg"
            >
                <Modal.Body>
                    <Modal.Header closeButton>
                        <h6 className="fw-bold pry-text ml-auto">
                            Confirm Order
                        </h6>
                    </Modal.Header>

                    <section className="addinvent">
                        <div className="container-fliud">
                            <div className="">
                                {/* Customer details */}
                                <div className="my-4">
                                    <h6 className="pry-bold-text pb-2 border-primary border-bottom "> Customer Details</h6>
                                </div>
                                <div className="my-4">
                                    <p className="mb-1">
                                        Name: {orderField?.customer_name}
                                    </p>
                                    <p className="mb-1">
                                        Phone: {orderField?.customer_phone}
                                    </p>
                                    <p className="mb-1">
                                        Email: {orderField?.customer_mail}
                                    </p>
                                    <p className="mb-1">
                                        Description: {orderField?.details}
                                    </p>
                                </div>

                                {/* Customer details */}



                                {/* Order Details */}
                                <div className="my-4">
                                    <h6 className="pry-bold-text pb-2 border-primary border-bottom "> Order Details</h6>
                                </div>
                                <MDBTable small responsive bordered>
                                    <MDBTableHead color=" pry-bold-text" >
                                        <tr>
                                            <th>No.</th>
                                            <th>Item Name</th>
                                            <th>Quantity</th>
                                            <th>Price</th>
                                            <th>Amount</th>
                                        </tr>
                                    </MDBTableHead>
                                    <MDBTableBody color="white" >
                                        {orderItem?.map((item, i) => (
                                            <tr key={i}>
                                                <td>{i + 1}</td>
                                                <td className="pt-3-half">
                                                    {item.item_name}
                                                </td>
                                                <td>
                                                    {item.qty}
                                                </td>
                                                <td>
                                                    ₦{th(item.price)}
                                                </td>
                                                <td>
                                                    ₦{th(item.amount)}
                                                </td>
                                            </tr>
                                        ))}

                                        {orderItem == 0 ?
                                            <> </>
                                            :
                                            <>
                                                <tr >
                                                    <td>=</td>
                                                    <td className="fw-bold py-3">
                                                        VAT ({businessData?.vat_rate || 0.00}%)
                                                    </td>
                                                    <td>

                                                    </td>
                                                    <td>

                                                    </td>
                                                    <td className='fw-bold py-3'>
                                                        ₦{th(vat_value)}
                                                    </td>

                                                </tr>
                                                <tr >
                                                    <td>=</td>
                                                    <td className="fw-bold py-3">
                                                        Total
                                                    </td>
                                                    <td>

                                                    </td>
                                                    <td>

                                                    </td>
                                                    <td className='fw-bold py-3'>
                                                        ₦{total_vat}
                                                    </td>

                                                </tr>
                                            </>
                                        }


                                    </MDBTableBody>
                                </MDBTable>
                                {/* Order Details */}
                                <p className="mb-1">
                                    Payment: {orderField?.pay_mode}
                                </p>
                                <p className="mb-1">
                                    VAT type: <span className="text-capitalize"> {orderField?.vat_type} </span>
                                </p>
                                <div className="mb-4 border-primary border-bottom "></div>
                                {sending ?
                                    <div className="text-center">
                                        <Button pry className="btn w-md-100" disabled>
                                            loading...
                                        </Button>
                                    </div> :
                                    <div className="d-flex justify-content-center">
                                        <div className="text-center mx-1">
                                            <Button className="btn btn-outline-primary w-md-100"
                                                onClick={() => closeConfirmSales()}>Cancel</Button>
                                        </div>
                                        <div className="text-center mx-1">
                                            <Button type="submit" pry className="btn w-md-100"
                                                onClick={e => salesAdd(e)}>Confirm</Button>
                                        </div>
                                    </div>
                                }

                            </div>
                        </div>
                    </section>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default ConfirmSales;
